export const WEBSITE_BANNER_HEIGHT_MOBILE = 68;
export const WEBSITE_BANNER_HEIGHT_DESKTOP = 77;
